/* @flow */

import {
  UPCOMING_EVENTS,
  PAST_EVENTS
} from './actions';

const PRIVATE_VISIBILITY: string = 'PRIVATE';

export const showingUpcomingEvents = (state: AnyMap) => !state.profile.events || state.profile.events === UPCOMING_EVENTS;
export const showingPastEvents = (state: AnyMap) => state.profile.events === PAST_EVENTS;
export const showFlashMessage = (state: AnyMap) => state.profile.flashMessage;
export const isPrivate = (profile: { visibility: ProfileVisibility }) => profile && profile.visibility === PRIVATE_VISIBILITY;



// WEBPACK FOOTER //
// ./src/modules/profile/getters.js